import { PageBack } from "@/components/elements/PageBack";
import { Tag } from "@/components/elements/Tag";
import { black, button, text } from "@/theme/colors";
import { TRequiredOne } from "@/types/common";
import { Stack, Typography } from "@mui/material";
import { FC, ReactNode } from "react";

export type TTopPageProps = {
  title: string;
  subTitle?: ReactNode;
  description?: string;
  rightContent?: ReactNode;
  isDraft?: boolean;
  tooltip?: ReactNode;
  gap?: number;
} & TRequiredOne<{ backUrl: string; enablePageBack: boolean }>;

export const TopPage: FC<TTopPageProps> = ({ title, subTitle, description, backUrl, enablePageBack = true, rightContent, isDraft, tooltip, gap }) => {
  return (
    <Stack gap={gap ?? 3} pb={1}>
      {enablePageBack && <PageBack backUrl={backUrl} />}
      <Stack direction="row" gap={3} alignItems="center">
        <Stack flex={1}>
          <Stack>
            <Stack flexDirection="row" alignItems="center" gap={2}>
              <Typography variant="head20Bold">{title}</Typography>
              {isDraft && <Tag title="下書き" variant="bold" color={button.secondary} textColor={text.white} />}
              {tooltip}
            </Stack>
            {subTitle && (
              <Typography
                variant="body14"
                sx={{
                  marginTop: "24px",
                  color: black[70],
                }}
              >
                {subTitle}
              </Typography>
            )}
          </Stack>
          {description && (
            <Typography sx={{ whiteSpace: "pre-line" }} variant="body14" component="p" mt={2} color={black[70]}>
              {description}
            </Typography>
          )}
        </Stack>
        {rightContent}
      </Stack>
    </Stack>
  );
};
